import history from '../../../../history'
import { useSelector } from 'react-redux'
import { defineMessages, useIntl } from 'react-intl'
import { OVERLAY_HELPERS } from '../../../../constants/navigation'
import { Button, Icon, ComponentTrackingType, Text } from '@homebotapp/hb-react-component-catalog'
import { selectInstantOfferEnabled } from '../../../../store/selectors/powerUps'

const MSG = defineMessages({
  instantOffer: {
    id: 'Homeowner.instantOffer.cta',
    defaultMessage: 'Get an instant offer'
  }
})

interface InstantOfferButtonProps {
  className?: string
  tracking?: ComponentTrackingType
}

export const InstantOfferButton = ({ className, tracking }: InstantOfferButtonProps) => {
  const intl = useIntl()
  const instantOfferEnabled = useSelector(selectInstantOfferEnabled)

  if (!instantOfferEnabled) {
    return null
  }

  const openInstantOfferModal = () => {
    history.push(OVERLAY_HELPERS.instantOffer.buildPath())
  }

  return (
    <Button
      className={className}
      onClick={openInstantOfferModal}
      leftIcon={
        <Text as='span' color='success'>
          <Icon name='dollar' />
        </Text>
      }
      tracking={{
        ...tracking,
        descriptor: MSG.instantOffer.defaultMessage
      }}
    >
      {intl.formatMessage(MSG.instantOffer)}
    </Button>
  )
}
